import * as types from '../actionTypes/SigninActionTypes';

function SigninReducer(state = {}, action = {}) {
    switch (action.type) {
        case types.POST_SIGNIN_REQUEST_ERROR:
        case types.POST_SIGNIN_REQUEST_SUCCESS: {
            return { ...state, ...action.payload };
        }
        case types.CLEAR_SIGNIN_DETAILS: {
            const signInDetails = {};
            return { ...signInDetails };
        }

        default:
            return state;
    }
}

SigninReducer.reducerName = 'signInDetails';
export default SigninReducer;
